import { render, staticRenderFns } from "./hqglLogisticsFixAttach.vue?vue&type=template&id=3c68d684&scoped=true&"
import script from "./hqglLogisticsFixAttach.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsFixAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68d684",
  null
  
)

export default component.exports